import { categories } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories';
import {
  modifyCategories,
  categoryModifications,
} from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories-helpers';
import type { GoalSchema } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

const volumeCategories = modifyCategories(
  categories,
  categoryModifications.volume
);

export const Volume: GoalSchema = {
  Volume: {
    subType: null,
    funnelMetric: [
      {
        value: 'Application',
        label: 'Application',
      },
      {
        value: 'Enrollment',
        label: 'Enrollment',
      },
    ],
    valueType: 'NUMBER',
    categories: volumeCategories,
  },
};
